import { createRef, useCallback } from 'react'
import { BottomSheetModal } from '@gorhom/bottom-sheet'

export const supportFormModalRef = createRef<BottomSheetModal>()

export const useSupportFormModal = () => {
  const open = useCallback(() => {
    supportFormModalRef.current?.present()
  }, [])

  const close = useCallback(() => {
    supportFormModalRef.current?.close()
  }, [])

  return {
    ref: supportFormModalRef,
    open,
    close
  }
}
